// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'press.admin',
    path: 'P0101ChoiceArticle/index',
    name: 'TTC PRESS Featured List',
    component: () => import('./PgMainPage'),
    meta: {
      roles: ['SA', 'PA', 'VA', 'PAP', 'PAL', 'PAC', 'PAA']
    }
  }
]
